console.log('GOGNA APP Version 1')
const pageType = ShopifyAnalytics?.meta?.page?.pageType || gogna_page_type;
const serverPath = "https://app.gogna.me";
const shop = Shopify.shop;
let customerId = ShopifyAnalytics?.meta?.page?.customerId;
const currencyCode = ShopifyAnalytics?.meta?.currency || "USD";
const productId = ShopifyAnalytics?.meta?.product?.gid || ''
let cartItems = [];
let data = null;
let selectedProductData = [];
let nameTapesProducts = null
let inputData = [];
const addToCartButton = document.querySelector('button[name="add"]');
let totalCartPrice = 0;
function getCurrencySymbol(currencyCode) {
  const currencySymbols = {
    INR: "₹", // Indian Rupee
    USD: "$", // US Dollar
    EUR: "€", // Euro
    GBP: "£", // British Pound
    JPY: "¥", // Japanese Yen
    CNY: "¥", // Chinese Yuan
    AUD: "A$", // Australian Dollar
    CAD: "C$", // Canadian Dollar
  };
  return (
    currencySymbols[currencyCode?.toUpperCase() || "USD"] ||
    `Symbol not found for ${currencyCode}`
  );
}

const currencySymbol = getCurrencySymbol(currencyCode);
document.addEventListener("DOMContentLoaded", () => {
  switch (pageType) {
    case "product":
      return productPage();
    default:
      break;
  }
});

function productPage() {
  getPackageDetail();

  const checkoutBtn = document.querySelector('[name="checkout"]');
  if (!checkoutBtn) return;

  checkoutBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    // Disable button and show spinner
    checkoutBtn.textContent = "";
    checkoutBtn.style.pointerEvents = "none";

    const spinner = document.createElement("div");
    spinner.className = "gogna-custom-spinner";
    checkoutBtn.appendChild(spinner);

    try {
      await getCartItems();
      await checkoutFunctionality();
    } catch (error) {
      console.error("Checkout failed:", error);
    } finally {
      spinner.remove();
      checkoutBtn.textContent = "Proceed to checkout";
      checkoutBtn.style.pointerEvents = "";
    }
  });
}

const getCartItems = async () => {
  try {
    const res = await fetch("/cart.json");
    let cart = await res.json();
    cartItems = cart?.items || [];
    return cart?.items || [];
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};

const getPrice = (id, cartIndex) => {
  let data = null;
  cartItems.forEach((item, index) => {
    let properties = item?.properties;
    let priceVal = 0;
    if (
      properties &&
      typeof properties === "object" &&
      Object.keys(properties).length > 0
    ) {
      Object.entries(properties).forEach(([key, value]) => {
        const parts = value?.split(",");
        const quantity = Number(parts[0]);
        const price = Number(parts[1]);
        const newValue = price * quantity;
        priceVal += newValue;
      });
    }
    if (item.id == id && index == cartIndex) {
      data = {
        price: Number(priceVal) > 0 ? priceVal : item?.price / 100,
        quantity: Number(item?.quantity),
        line_price: item?.line_price / 100,
      };
    }
  });
  if (data) {
    return data;
  } else {
    return {
      price: 0,
      quantity: 0,
      extraCharges: 0,
      line_price: 0,
    };
  }
};

const changeLineItemPrice = (price, cartIndex) => {
  setTimeout(() => {
    let tr = document.getElementById(`CartItem-${cartIndex}`);
    if (tr) {
      let lastTd = tr.querySelector("td.cart-item__totals.small-hide");
      if (lastTd) {
        let priceElement2 = lastTd?.querySelector("span.price.price--end");
        if (priceElement2 && price) {
          priceElement2.innerText = `${currencySymbol} ${Number(price).toFixed(
            2
          )}`;
        } else {
          console.log("can't change cart price");
        }
      }
    }
  }, 1000);
};

const targetRow = (tr,index) => {
  let cartIndex = Number(tr.id.split("-")[1]);
  if (tr) {
    let lastTd = tr.querySelector("td.cart-item__totals");
    let priceElement = lastTd?.querySelector(".price.price--end");
    if (priceElement) {
      let input = tr.querySelector("input.quantity__input");
      if (input) {
        let data = getPrice(input.dataset.quantityVariantId, cartIndex - 1);
        data.quantity = Number(input.value);
        let price =
          Number(data?.price) * data.quantity +
          Number(
            data?.extraCharges ? Number(data?.extraCharges) * data.quantity : 0
          );
        totalCartPrice = totalCartPrice + price;
        changeLineItemPrice(price, cartIndex);
        changeCustomCartContent(price,index)
      }
    }
  }
};

const changeCustomCartContent = (price,index) =>{
    const cartContent = document.querySelector(".cstm-cart-content");
      if (cartContent) {
        const priceEnd = cartContent.querySelectorAll("span.price.price--end");
        if (priceEnd) {
          priceEnd[index].innerText = `${currencySymbol} ${Number(
            price
          ).toFixed(2)}`;
        }
      }
}

const createDraftOrder = async (cartList, customNote) => {
  const body = {
    shop: shop,
    note: customNote || "",
    lineItems: cartList,
  };

  const res = await fetch(`${serverPath}/api/create-draft-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const data = await res.json();
  if (data.invoiceUrl) {
    window.location.href = data.invoiceUrl;
  } else {
    console.error("Draft order creation failed", data.errors);
  }
};




function decodeHTMLEntities(str) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}


const checkoutFunctionality = async () => {
    const cartList = [];
    let customNote = "";

    cartItems?.forEach((item) =>{
      const { properties, quantity, title, variant_id } = item;

      const isValidProperties = properties && typeof properties === "object" && Object.keys(properties).length > 0;
      const hasGidKey = isValidProperties && Object.keys(properties).some((key) => key.startsWith("_gid"));

      if (hasGidKey) {
        customNote += (customNote ? ", " : "") + title;

        // for (const [key, value] of Object.entries(properties)) {
        //   const [qtyStr, priceStr,namePrice,name,secName] = value.split(",");
        //   const addOn = Number(namePrice) || 0 
        //   const v = Number(qtyStr) || 1;
        //   const finalAddon = addOn 
        //   const variantId = key.split("_")[1];
        //   const mainItem = {
        //     quantity: quantity * v,
        //     variantId,
        //     priceOverride: {
        //       amount: Number(priceStr)+finalAddon,
        //       currencyCode,
        //     },
        //   }
        
        //   if (namePrice && name) {
        //     const customAttributes = [];
          
        //     // Only add "Additional Charges" if namePrice is not zero
        //      if (Number(namePrice) !== 0) {
        //        const additionalPrice = Number(namePrice) * quantity
        //       customAttributes.push({
        //         key: "Additional Charges",
        //         value: additionalPrice.toString()
        //       });
        //     }

          
        //     // Always add "Name"
        //     customAttributes.push({
        //       key: "Name",
        //       value: decodeHTMLEntities(name)
        //     });
          
        //     // Optionally add "Name 2" if secName exists
        //     if (secName) {
        //       customAttributes.push({
        //         key: "Name 2",
        //         value: decodeHTMLEntities(secName)
        //       });
        //     }
          
        //     mainItem.customAttributes = customAttributes;
        //   }
          
        //   cartList.push(mainItem)

        // }

         for (const [key, value] of Object.entries(properties)) {
          const valueArr = value.split(","); 
          const [qtyStr, priceStr,namePrice] = valueArr
          const addOn = Number(namePrice) || 0 
          const v = Number(qtyStr) || 1;
          const finalAddon = addOn

          const variantId = key.split("_")[1];
           const mainItem = {
            quantity: quantity * v ,
            variantId,
            priceOverride: {
              amount:Number(priceStr) + finalAddon,
              currencyCode,
            },
          }
           
          if (namePrice && valueArr.length > 3) {
            const customAttributes = [];
             if (Number(namePrice) !== 0) {
                  const additionalPrice = Number(namePrice) * quantity
                 customAttributes.push({
                   key: "Additional Charges",
                   value: additionalPrice.toString()
                 });
               }
            valueArr.slice(3).forEach((name,index)=>{
                 customAttributes.push({
                 key: `Name ${index > 0 ? index :''}`,
                 value: decodeHTMLEntities(name)
                });
            })
             mainItem.customAttributes = customAttributes;
            
          }
        cartList.push(mainItem)
        }
      } else {
        cartList.push({
          quantity,
          variantId: `gid://shopify/ProductVariant/${variant_id}`,
        });
      }
    });

    await createDraftOrder(cartList, customNote);
  }
const disableAddToCartbutton = () => {
  if (addToCartButton) {
    addToCartButton.setAttribute("disabled", "true");
  }
};

const enableAddToCartbutton = () => {
  if (addToCartButton) {
    addToCartButton.removeAttribute("disabled");
  }
};

const checkCharges = (product) => {
  let totalCharges = 0;
  if (product?.calculatedPrice) {
    let productPrice = productJson.price / 100;
    actual = (productPrice * product?.percentage) / 100;
    if (actual < product.calculatedPrice) {
      totalCharges = Number(product.calculatedPrice) - actual;
    }
  }
  return Number(totalCharges).toFixed(2);
};

const sendDataToCart = () => {
    clearCartProperties() 

    let productForms = document.querySelectorAll('form[action="/cart/add"]');
    productForms.forEach((form) => {
        if (!form) return;

        let extraCharges = 0;
        const variantTracker = [];

        selectedProductData?.forEach((item) => {
            const product = item?.selectedProduct;
            if (!product) return;

            const { variant_id: variantId, nameTape, nameTapePrice, calculatedPrice } = product;
       
            if (!variantId) return;

            const inputName = `properties[_${variantId}]`;
            let productInput = form.querySelector(`input[name="${inputName}"]`);

            // Find or initialize variant data
            let variantData = variantTracker.find(entry => entry.id === variantId);

            if (!variantData) {
                variantData = {
                    id: variantId,
                    productCount: 1,
                    nameTapePrice: nameTape ? Number(nameTapePrice): 0,
                    nameTapeList: nameTape ? [nameTape] : []
                };
                variantTracker.push(variantData);

                // Create input if it doesn't exist
                if (!productInput) {
                    productInput = document.createElement("input");
                    productInput.type = "hidden";
                    productInput.name = inputName;
                    form.appendChild(productInput);
                }
            } else {
                variantData.productCount += 1;
                variantData.nameTapePrice += nameTape ? Number(nameTapePrice): 0;
                if (nameTape) variantData.nameTapeList.push(nameTape);
            }

            // Set input value using updated variantData
            const nameTapes = variantData.nameTapeList.join(",");
            const tapePriceTotal = nameTapePrice == null ? "" : variantData.nameTapePrice;
          

            productInput.value = nameTapes
                ? `${variantData.productCount},${Number(calculatedPrice).toFixed(2)},${Number(tapePriceTotal)},${nameTapes}`
                : `${variantData.productCount},${Number(calculatedPrice).toFixed(2)}`;

            // Add additional charges if any
            extraCharges += Number(checkCharges(product));
        });
        if (selectedProductData[selectedProductData?.length - 1]?.updated) {
            enableAddToCartbutton()
        } else {
            disableAddToCartbutton()
        }
    });
};

const sendDataToCartOnlySingleProduct = (nPrice) => {
  const productForms = document.querySelectorAll('form[action="/cart/add"]');
  const priceElement = document.querySelector("[data-price]");
  const addButton = document.querySelector('[name="add"]');
  const idInput = document.querySelector('[name="id"]');

  if (!priceElement || !addButton || !idInput) return;

  // const price = priceElement.dataset.price;
  // const variantId = `gid://shopify/ProductVariant/${idInput.value}`;

  // Avoid duplicate custom button
  if (addButton.parentElement.querySelector('.custom-cart-btn')) return;

  const customBtn = addButton.cloneNode(true);
  customBtn.classList.add('custom-cart-btn');
  customBtn.type = 'button';
  addButton.classList.add('hidden');
  addButton.parentElement.appendChild(customBtn);

    customBtn?.addEventListener('click', () => {
  const inputEl = document.querySelector('.name-tape-input');
  const inputText = inputEl?.value.trim() || '';

  // Remove existing error messages
  const existingError = inputEl?.parentElement?.querySelector('.input-error-msg');
  if (existingError) existingError.remove();

  if (inputText.length === 0) {
    const errorDiv = document.createElement('div');
    errorDiv.textContent = "⚠️ Please fill the required field.";
    errorDiv.className = "input-error-msg";
    errorDiv.style.color = "red";
    errorDiv.style.marginTop = "4px";
    inputEl?.parentElement?.appendChild(errorDiv);
    return;
  }

  const quantity = Number(document.querySelector('[name="quantity"]')?.value || 1);
  const spinner = document.createElement('div');
  spinner.className = 'gogna-custom-spinner';

  // Replace button content with spinner
  customBtn.textContent = '';
  customBtn.appendChild(spinner);

  productForms.forEach((form) => {
    if (!form) return;

    form.querySelectorAll('input[name^="properties[_gid://shopify/ProductVariant/"]').forEach(input => {
      input.remove();
    });

    // const inputName = `properties[_${variantId}]`;

    // // Remove existing hidden input if present
    // const existingInput = form.querySelector(`input[name="${inputName}"]`);
    // if (existingInput) existingInput.remove();

    const variantId = `gid://shopify/ProductVariant/${idInput.value}`;
    const inputName = `properties[_${variantId}]`;
    const priceElement2 = document.querySelector("[data-price]");

    const variants = ShopifyAnalytics.meta.product.variants;
    const selectedVariant = variants.find(v => v.id == idInput.value);
    const price = (selectedVariant.price / 100).toFixed(2) || priceElement2.dataset.price;

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = inputName;
    hiddenInput.value = `1,${Number(price).toFixed(2)},${nPrice},${inputText}`;

    form.appendChild(hiddenInput);
  });

  addButton?.click();

  // Reset button UI after a short delay
  setTimeout(() => {
    if (spinner.parentElement === customBtn) spinner.remove();
    customBtn.textContent = 'Add to cart';
  }, 300);
});

   
};


const clearCartProperties = () => {
  const productForms = document.querySelectorAll('form[action="/cart/add"]');

  productForms.forEach((form) => {
    if (!form) {
      console.warn("To set properties form not found");
      return;
    }

    // Select all input elements with name starting with "properties["
    const propertyInputs = form.querySelectorAll('input[name^="properties["]');

    propertyInputs.forEach((input) => {
      input.remove();
    });
  });
};

async function getPackageDetail() {
  try {
    const response = await fetch(`${serverPath}/api/getApi`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        shop,
        productId: `gid://shopify/Product/${productJson.id}`,
      }),
    });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const result = await response?.json();
    if (result.message == "success") {
      data = result?.details;
      nameTapesProducts = result?.nameTape?.products || null
      if (data) {
        const cleanedItems = data?.products.map((item) => {
          const { items } = item;
          cleanedProducts = items?.map((product) => {
            const { variants, options } = product;
            const filteredOptions = options.map((option) => {
              const { position } = option;
              const matchingValues = new Set(
                variants.map((v) => v.title.split(" / ")[position - 1])
              );
              const filteredValues = option.values.filter((value) =>
                matchingValues.has(value)
              );

              return {
                ...option,
                values: filteredValues,
              };
            });
            return {
              ...product,
              options: filteredOptions,
            };
          });
          return {
            ...item,
            items: cleanedProducts,
          };
        });

        data.products = cleanedItems;
        handleInitiallySelect();
        data ? blockUi() : "";
      } else {
        const matchedProduct = nameTapesProducts.find(item => item.id === productId);
        if(matchedProduct){
          const main = document.getElementById("gogna-app-block");
          const div = document.createElement("div");
          div.className = "product-name-taps";
          const nameLabel = Number(matchedProduct?.price) === 0 ? "Name" : `Name (${currencyCode}${Number(matchedProduct?.price).toFixed(2)})`
          const p = document.createElement("p");
          const span =  document.createElement("span")
          span.innerText = "*"
          p.textContent = nameLabel;

          const input = document.createElement("input");
          input.type = "text";
          input.className = "name-tape-input";
          input.id = "custom-input"
          p.appendChild(span)
          div.appendChild(p);
          div.appendChild(input);
          main.appendChild(div);
          sendDataToCartOnlySingleProduct(Number(matchedProduct.price)) 
        }
      }
    } else {
      console.error("Failed to fetch package details:", result);
    }
  } catch (error) {
    console.error("Error:", error);
  }
}

const handleToggle = (displayName) => {
  let up = `<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1.37527L6 6.47656L11 1.37527" stroke="#1C1C1C" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
  let down = ` <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
<path d="M11 6.62799L6 1.5267L1 6.62799" stroke="#1C1C1C" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>`;
  let mainIndex = selectedProductData.findIndex(
    (item) => item.displayName === displayName
  );

  let data = selectedProductData[mainIndex - 1];

  if (data?.updated || mainIndex == 0) {
    let ele = document.getElementById(`${displayName}`);
    let ele2 = document.getElementById(`${displayName}-caret`);
    if (!ele) {
      return;
    }
    ele.style.display = ele.style.display === "flex" ? "none" : "flex";
    ele.style.display === "flex"
      ? (ele2.innerHTML = down)
      : (ele2.innerHTML = up);
  } else if (!data?.updated) {
    let ele = document.getElementById(`${displayName}`);
    let ele2 = document.getElementById(`${displayName}-caret`);
    if (!ele) {
      return;
    }
    ele.style.display = "none";
    ele2.innerHTML = up;
  }
};

function escapeAttr(str = "") {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

const blockUi = () => {
  disableAddToCartbutton();
  const main = document.getElementById("gogna-app-block");
  const blockUi = document.createElement("div");
  blockUi.className = "block-ui";
  const loader = document.createElement("div");
  loader.className = "loader";
  blockUi.appendChild(loader);

  if (main) {
    main.appendChild(blockUi);
    data?.products?.forEach((item, productIndex) => {
      const { items, displayName } = item;

      // Create main-item wrapper
      const itemElement = document.createElement("div");
      itemElement.className = "main-item";

      // Create product-head
      const productHead = document.createElement("div");
      productHead.className = "product-head";
      productHead.dataset.displayName = displayName;

      // Create heading
      const heading = document.createElement("h3");
      heading.textContent = displayName;

      // Create caret span
      const caretSpan = document.createElement("span");
      caretSpan.id = `${displayName}-caret`;

      // Create SVG
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "12");
      svg.setAttribute("height", "8");
      svg.setAttribute("viewBox", "0 0 12 8");
      svg.setAttribute("fill", "none");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

      const path = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      path.setAttribute("d", "M1 1.37527L6 6.47656L11 1.37527");
      path.setAttribute("stroke", "#1C1C1C");
      path.setAttribute("stroke-width", "1.8");
      path.setAttribute("stroke-linecap", "round");
      path.setAttribute("stroke-linejoin", "round");

      svg.appendChild(path);
      caretSpan.appendChild(svg);

      productHead.appendChild(heading);
      productHead.appendChild(caretSpan);
      itemElement.appendChild(productHead);
      blockUi.appendChild(itemElement);

      if (productIndex == 0) {
        itemElement
          ?.getElementsByClassName("product-head")[0]
          .classList.add("active");
      }
      if (items?.length == 1) {
        items?.map((product) => {
          let selectedData = selectedProductData.find(
            (itm) => itm?.displayName === product?.displayName
          );
          const productName = product.handle;
          const productImage = product.product_image;
          const productElement = document.createElement("div");
          productElement.className = "product-content";
          productElement.id = product?.displayName;


          const matchedProduct = nameTapesProducts.find(item => item.id === product?.product_id);

          let productHTML = `
              <div class="product-image">
                  <img src="${productImage}" alt="${productName}" height="130" width="100">
              </div>
              <div class="product-title">
                  <h4>${productName}</h4>
              </div>
              <div class="product-variants-box" id="variants-box-product--${productIndex}"></div>
              `;
          if (matchedProduct) {
              const nameLabel = Number(matchedProduct?.price) === 0 ? "Name" : `Name (${currencyCode}${Number(matchedProduct?.price).toFixed(2)})`
              productHTML += `
                      <div class="product-name-taps">
                          <p>${nameLabel}</p>
                          <input type="text" data-index="${productIndex}" class="name-tape-input" />
                      </div>
                  `;
              product['nameTape'] = null
          }
          

          productElement.innerHTML = productHTML;
          itemElement.appendChild(productElement);
          optionsCreate(product, productElement);

          function sanitizeInput(input) {
            return input
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#x27;")
              .replace(/\//g, "&#x2F;")
              .replace(/,/g, '&#44;');
          }

          // Attach input handler
          const input = productElement.querySelector('.name-tape-input');
          if (input) {
              input.addEventListener('input', (e) => {
                  nameTapeUpdate(product, sanitizeInput(e.target.value))
                  // nameTapeUpdate(product, e.target.value)
                  optionsCreate(product, productElement);
              });
          }
        });
      } else {
        const productElement = document.createElement("div");
        itemElement.appendChild(productElement);
        productElement.className = "product-content additional-option";
        const productsImagesMain = document.createElement("div");
        const breakLine = document.createElement("br");
        productsImagesMain.className = "product-images-main-div";
        productElement.appendChild(productsImagesMain);
        productElement.appendChild(breakLine);
        const productTitle = document.createElement("div");
        productTitle.className = "product-title";
        productElement.appendChild(productTitle);
        productTitle.innerHTML = `<h4></h4>`;
        const productsOptions = document.createElement("div");
        productsOptions.className = "product-variants-box";
        productElement.appendChild(productsOptions);

        // Create a unique name for the radio group per product group
        const radioGroupName = `product-group-${productIndex}`;

        items?.forEach((product, additionalIndex) => {
          const productId = product?.product_id;
          productElement.id = product?.displayName;
          const productName = product.handle;
          const productImage = product.product_image;

          const label = document.createElement("label");
          label.className = "product-radio-label";

          const input = document.createElement("input");
          input.type = "radio";
          input.name = radioGroupName;
          input.value = productId;
          input.style.display = "none";

          if (additionalIndex === 0) {
            input.checked = true;
            label.classList.add("selected");
            optionsCreate(product, productElement);
          }
          const imageWrapper = document.createElement("div");
          imageWrapper.className = `product-image-${productIndex}-${additionalIndex}`;
          imageWrapper.innerHTML = `<img src="${productImage}" alt="${productName}" height="180" width="150">`;

          // Add visual selection feedback via a class
          input.addEventListener("change", () => {
            const allLabels = productsImagesMain.querySelectorAll("label");
            allLabels.forEach((l) => l.classList.remove("selected"));
            label.classList.add("selected");
            clearCartProperties();
            updateProduct(product);
          });

          label.appendChild(input);
          label.appendChild(imageWrapper);
          productsImagesMain.appendChild(label);
        });
      }
      sendDataToCart();
    });
    // Event delegation for toggle
    blockUi.addEventListener("click", (e) => {
      const head = e.target.closest(".product-head");
      if (head) {
        const name = head.dataset.displayName;
        handleToggle(name);
      }
    });
    document.addEventListener("change", (e) => {
      const input = e.target;

      if (
        input.matches('input[type="radio"][data-product-id]') &&
        input.checked
      ) {
        const productId = input.dataset.productId;
        const value = input.dataset.value;
        const optionName = input.dataset.optionName;
        const displayName = input.dataset.displayName;

        updateVariant(productId, value, optionName, displayName);
      }
    });
  }
};

const nameTapeUpdate = (product, nameValue) => {
    const index = selectedProductData.findIndex(item => item.displayName === product?.displayName);
    if (index === -1) {
        console.warn("Product not found in selectedProductData");
        return;
    }
    const data = selectedProductData[index].selectedProduct

    const selectedOptions = data?.selectedOptions || [];
    const nameTapePrice = data?.nameTapePrice || null;

    selectedProductData[index] = {
        displayName: product.displayName,
        updated: true,
        selectedProduct: {
            product_id: data.product_id,
            product_name: data.product_name,
            variant_id: data.variant_id,
            calculatedPrice: data.calculatedPrice,
            percentage: data.percentage,
            variant_title: data.variant_title,
            selectedOptions,
            nameTapePrice,
            nameTape: nameValue == "" ? null : nameValue,
        },
    };
    sendDataToCart()
};


const clearSelectedData = (productId, displayName) => {
  const index = selectedProductData.findIndex(
    (item) => item.displayName === displayName
  );
  if (index !== -1) {
    let productToUpdate = [];
    let arr = [];
    selectedProductData.map((item, i) => {
      if (item.displayName === displayName || i >= index) {
        let productElem = document.getElementById(item.displayName);

        if (i > index) {
          const prevElem = productElem.previousElementSibling;
          if (prevElem && prevElem.classList.contains("active")) {
            prevElem.classList.remove("active");
            arr.push(item.displayName);
          }
        }

        let elem = productElem.getElementsByClassName("selected");
        Array.from(elem).forEach((el) => {
          el.classList.remove("selected");
          let input = el.querySelector("input");
          if (input) {
            input.checked = false;
          }
        });

        productToUpdate.push({
          ...selectedProductData[i],
          updated: false,
        });
      } else {
        productToUpdate.push(item);
      }
    });
    selectedProductData = productToUpdate;

    //to change toggle button
    arr.forEach((itm) => {
      handleToggle(itm);
    });
  }
};

const optionsCreate = (product, productElement) => {
  let selectedData = selectedProductData.find(
    (itm) => itm?.displayName === product?.displayName
  );
  const index = selectedProductData.findIndex(item => item.displayName === product?.displayName);
  let titleDiv = productElement.getElementsByClassName("product-title")[0];
  if (titleDiv) {
    titleDiv.getElementsByTagName("h4")[0].innerText =
      selectedData?.selectedProduct?.product_name;
  }
  const selectedVariantTitle = selectedData.selectedProduct.variant_title;
  const hasUpdated = selectedData?.updated;
  // const inputValue = document.querySelectorAll(".name-tape-input")[index];
  // let nValue = null;

  // if (inputValue) {
  //     nValue = inputValue.value?.trim(); // Trim to ignore white spaces
  // }
  // if (!inputValue || (inputValue && nValue)) {

  if (hasUpdated) {
      const nextActive = productElement.parentElement.nextElementSibling;
      if (nextActive) {
          nextActive.getElementsByClassName('product-head')[0].classList.add('active');
      }

  }
  // }

  let varinatBox = productElement.getElementsByClassName(
    "product-variants-box"
  )[0];
  const productId = product?.product_id;
  const displayName = product?.displayName;
  const selectedOptions = selectedVariantTitle?.split(" / ");

  varinatBox.innerHTML = `
        <div class="product-options">
            ${product.options
              .map((option, optionIndex) => {
                const optionName = option.name;

                if (optionName.toLowerCase() !== "brand") {
                  return `
                        <p class="option-name">${optionName}</p>
                        <div class="option-values-box">
                            ${option.values
                              .map((value) => {
                                let isSelected =
                                  selectedOptions.includes(value);
                                let isDisabled = false;

                                // For options after the first one (e.g., color, brand)
                                if (
                                  optionIndex == 0 &&
                                  selectedOptions.length > 1
                                ) {
                                  const hasVariants = product.variants.filter(
                                    (variant) =>
                                      variant.title.includes(selectedOptions[1])
                                  );
                                  let arr = [];
                                  hasVariants.map((variant, i) => {
                                    let title = variant?.title.split(" / ");
                                    arr.push(title[0]);
                                  });
                                  if (!arr.includes(value)) {
                                    isDisabled = true;
                                  }
                                } else if (optionIndex == 1) {
                                  const hasVariants = product.variants.filter(
                                    (variant) =>
                                      variant.title.includes(selectedOptions[0])
                                  );
                                  let arr = [];
                                  hasVariants.map((variant, i) => {
                                    let title = variant?.title.split(" / ");
                                    arr.push(title[1]);
                                  });
                                  if (!arr.includes(value)) {
                                    isDisabled = true;
                                  }
                                } else if (optionIndex == 2) {
                                  const hasVariants = product.variants.filter(
                                    (variant) =>
                                      variant.title.includes(selectedOptions[0])
                                  );
                                  let arr = [];
                                  hasVariants.map((variant, i) => {
                                    let title = variant?.title.split(" / ");
                                    arr.push(title[2]);
                                  });

                                  if (!arr.includes(value)) {
                                    isDisabled = true;
                                  }
                                }

                                const inputId = `${productId}-${optionName}-${value}`;
                                const checkedAttr =
                                  isSelected && hasUpdated ? "checked" : "";
                                const selectedClass =
                                  isSelected && hasUpdated ? "selected" : "";
                                const disabledAttr = isDisabled
                                  ? "disabled"
                                  : "";
                                return `
                                        <label class="${`variant-radio-label ${selectedClass}`}">
                                            <input
                                                type="radio"
                                                name="${escapeAttr(
                                                  optionName
                                                )}-${escapeAttr(productId)}"
                                                id="${escapeAttr(inputId)}"
                                                value="${escapeAttr(value)}"
                                                ${checkedAttr}
                                                ${disabledAttr}
                                                data-product-id="${escapeAttr(
                                                  productId
                                                )}"
                                                data-value="${escapeAttr(
                                                  value
                                                )}"
                                                data-option-name="${escapeAttr(
                                                  optionName
                                                )}"
                                                data-display-name="${escapeAttr(
                                                  displayName
                                                )}"
                                            >
                                            <span>${value}</span>
                                            <div class="slash-line"></div>
                                            </label>
                                        `;
                              })
                              .join("")}
                        </div>
                        `;
                }
              })
              .join("")}
            <span class="clearBtn" data-product-id="${productId}" data-display-name="${displayName}">
            clear </span>
        </div>
    `;
  document.querySelectorAll(".clearBtn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const productId = this.dataset.productId;
      const displayName = this.dataset.displayName;
      clearSelectedData(productId, displayName);
    });
  });

  const variantLabels = varinatBox.querySelectorAll(".variant-radio-label");
  variantLabels.forEach((label) => {
    const input = label.querySelector("input");
    if (input.disabled) return;
  });
};

const handleInitiallySelect = () => {
  data?.products?.forEach((item) => {
    const { displayName, items } = item;
    const product = items[0];
    const variant = product?.variants[0];
    const matchedProduct = nameTapesProducts?.find(item => item.id === product?.product_id);
    let nameTapePrice = null;
    if (matchedProduct) {
      nameTapePrice = matchedProduct?.price
    }

    const selectedOptions = product.options?.length
      ? getSelectedOptionsFromVariantTitle(product.options, variant?.title)
      : {};

    selectedProductData.push({
      displayName,
      updated: false,
      selectedProduct: {
        product_id: product.product_id,
        product_name: product.product_name,
        variant_id: variant.id,
        calculatedPrice: variant.calculatedPrice,
        percentage: variant.percentage,
        variant_title: variant.title,
        selectedOptions,
        nameTapePrice: nameTapePrice,
        nameTape: null
      },
    });
  });
};

const getSelectedOptionsFromVariantTitle = (options, title) => {
  const split = title.split(" / ");
  return options.reduce((acc, opt, idx) => {
    acc[opt.name] = split[idx] || "";
    return acc;
  }, {});
};

function updateVariant(productId, value, option, displayName) {
  const index = selectedProductData.findIndex(
    (item) => item.displayName === displayName
  );
  if (index === -1) {
    console.warn("Product not found in selectedProductData");
    return;
  }

  const productToUpdate = selectedProductData[index];

  // Step 2: Ensure selectedOptions is an OBJECT
  if (
    !productToUpdate.selectedProduct.selectedOptions ||
    Array.isArray(productToUpdate.selectedProduct.selectedOptions)
  ) {
    productToUpdate.selectedProduct.selectedOptions = {};
  }

  // Step 3: Update the selected option
  productToUpdate.selectedProduct.selectedOptions[option] = value;
  productToUpdate.updated = true;

  // Step 4: Get original product & variants
  const originalProductData = data?.products?.find(
    (p) => p.displayName === displayName
  );
  const originalProduct = originalProductData?.items?.find(
    (item) => item.product_id === productId
  );
  if (!originalProduct) {
    console.warn("Original product not found");
    return;
  }

  // Step 5: Match variant by comparing selectedOptions to variant title
  const selectedOptions = productToUpdate.selectedProduct.selectedOptions;

  const matchedVariant = originalProduct.variants.find((variant) => {
    const variantOptions = variant.title.split(" / ");
    return originalProduct.options.every((opt, idx) => {
      return variantOptions[idx] === selectedOptions[opt.name];
    });
  });
  // Step 6: If match found, update variant ID and title
  if (matchedVariant) {
    productToUpdate.selectedProduct.variant_id = matchedVariant.id;
    productToUpdate.selectedProduct.variant_title = matchedVariant.title;
    productToUpdate.selectedProduct.calculatedPrice =
      matchedVariant.calculatedPrice;
    productToUpdate.selectedProduct.percentage = matchedVariant.percentage;
  } else {
    console.warn("No matching variant found for selected options");
  }

  // Step 7: Save it back
  selectedProductData[index] = productToUpdate;
  let productElement = document.getElementById(originalProduct?.displayName);
  optionsCreate(originalProduct, productElement);
  sendDataToCart();
}

function updateProduct(product) {
  const index = selectedProductData.findIndex(
    (item) => item.displayName === product?.displayName
  );
  if (index === -1) {
    console.warn("Product not found in selectedProductData");
    return;
  }
  let nameTapePrice = null;
  const matchedProduct = nameTapesProducts.find(item => item.id === product?.product_id);
  if (matchedProduct) {
      nameTapePrice = matchedProduct?.price
  }
  
  let productToUpdate = selectedProductData[index];
  const variant = product?.variants[0];

  const selectedOptions = product.options?.length
    ? getSelectedOptionsFromVariantTitle(product.options, variant.title)
    : {};

  productToUpdate = {
    displayName: product?.displayName,
    selectedProduct: {
      product_id: product.product_id,
      product_name: product.product_name,
      variant_id: variant.id,
      variant_title: variant.title,
      calculatedPrice: variant.calculatedPrice,
      percentage: variant.percentage,
      selectedOptions: selectedOptions,
      nameTape: product.nameTape,
      nameTapePrice: nameTapePrice
    },
  };
  selectedProductData[index] = productToUpdate;
  let productElement = document.getElementById(product?.displayName);
  optionsCreate(product, productElement);
  sendDataToCart();
}

function checkDisable(product, productToUpdate = 1) {
  const selectedOptions = productToUpdate.selectedProduct.selectedOptions;

  const variantName = Object.values(selectedOptions).join(" / ");

  product?.variants.map((itm) => itm?.title == variantName);

  if (
    optionIndex === product.options.length - 1 &&
    product.options.length > 1
  ) {
    // If this is the second option (like Size), and first is selected
    const firstOptionValue = selectedOptions[0];
    const matchedVariant = product.variants.find(
      (variant) => variant.title === `${firstOptionValue} / ${value}`
    );

    if (!matchedVariant) {
      isDisabled = true;
    }
  }
}

